// extracted by mini-css-extract-plugin
export default {"button":"button_button__e01e1","black":"button_black__yV9Tw","white":"button_white__-27SX","fullWidth":"button_fullWidth__uYTRs"};